export const FADE_APPEAR_DURATION = 800;
export const FADE_DURATION = 600;

// export const FADE_STAGGER = 600;
export const FADE_STAGGER = 60;

// export const FADE_EASING = 'cubic-bezier(0.33, 1, 0.68, 1)'; // easeOutCubic
export const FADE_EASING = 'cubic-bezier(0.61, 1, 0.88, 1)'; // easeOutSine
